/**
 * Client-side JavaScript: Action Steps Rendering.
 * Renders the chronological action steps timeline in the drawer,
 * with category badges, duration, video seek, and nested step support.
 */

export const JS_ACTIONS = `
  /* ── Category badge helpers ── */
  function actionBadgeClass(cat){
    if(cat==='assertion')return 'action-badge-assertion';
    if(cat==='custom_step')return 'action-badge-custom';
    return 'action-badge-ui';
  }
  function actionBadgeLabel(cat){
    if(cat==='assertion')return 'assert';
    if(cat==='custom_step')return 'step';
    return 'action';
  }

  /* ── Render a single action step ── */
  function renderActionItem(a,hasVideo,depth){
    var h='<div class="action-step'+(a.status==='failed'?' action-failed':'')+(hasVideo&&a.videoOffset!==null?' seekable':'')+'" data-offset="'+(a.videoOffset!==null?a.videoOffset:'')+'" style="padding-left:'+(12+depth*16)+'px">';
    h+='<span class="action-badge '+actionBadgeClass(a.category)+(a.status==='failed'?' failed':'')+'">'+actionBadgeLabel(a.category)+'</span>';
    h+='<span class="action-title" title="'+esc(a.title)+'">'+esc(a.title)+'</span>';
    h+='<span class="action-duration">'+fmtDur(a.duration)+'</span>';
    if(hasVideo&&a.videoOffset!==null){
      h+='<span class="action-offset">@ '+a.videoOffset.toFixed(1)+'s</span>';
    }
    h+='</div>';
    if(a.status==='failed'&&a.error){
      h+='<div class="action-error" style="padding-left:'+(28+depth*16)+'px">'+esc(a.error)+'</div>';
    }
    if(a.children&&a.children.length>0){
      for(var c=0;c<a.children.length;c++){
        h+=renderActionItem(a.children[c],hasVideo,depth+1);
      }
    }
    return h;
  }

  /* ── Render the full actions column ── */
  function renderActionsColumn(actions,hasVideo){
    if(!actions||actions.length===0)return '';
    var h='<div class="actions-header"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 20V10M18 20V4M6 20v-4"/></svg>Actions <span class="actions-count">'+actions.length+'</span></div>';
    h+='<div class="actions-timeline">';
    for(var i=0;i<actions.length;i++){
      if(i>0)h+='<div class="action-connector"></div>';
      h+=renderActionItem(actions[i],hasVideo,0);
    }
    h+='</div>';
    return h;
  }
`;
